import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import { getColor } from '../system';
import Text from '../Text';
import { inputs, inputLabels } from './utils';

var InputLabel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InputLabel, _Component);

  function InputLabel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "focusInput", function () {
      _this.input && _this.input.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOver", function () {
      _this.input && _this.input.setState({
        isHovered: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseOut", function () {
      _this.input && _this.input.setState({
        isHovered: false
      });
    });

    return _this;
  }

  var _proto = InputLabel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.input = inputs[this.props.controls];
    inputLabels[this.props.controls] = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    delete inputLabels[this.props.controls];
  };

  _proto.render = function render() {
    var _this$props = this.props,
        controls = _this$props.controls,
        state = _this$props.state,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["controls", "state"]);

    if (controls) {
      restProps.id = controls + "-label";
    }

    if (state) {
      restProps.color = getColor(state);
    }

    return /*#__PURE__*/React.createElement(Text, _extends({
      as: "label",
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut,
      onClick: this.focusInput
    }, restProps));
  };

  return InputLabel;
}(Component);

InputLabel.displayName = 'Input.InputLabel';
export default InputLabel;